import { WebResourcePage } from './WebResourcePage';
export default WebResourcePage;
